// extracted by mini-css-extract-plugin
export default {"root":"close_root__lARI6"};